<template>
    <div>
        <div class="text-left text-xs bg-black text-white opacity-50 p-1">Schedule a tour</div>
        <div class="bg-gray-200 mb-8 p-4">
            <p class="text-xs">This will add the Schedule a Tour widget that is configured to connect to your integration partner.</p>
        </div>
    </div>
</template>